import { FlexComponent, ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";
import { getNameFromFlexComponent } from "src/stores/CompositionStore";
import { DescendantDepth, getNextDepth } from "src/components/flexFramework/FlexTemplateNode";

/**
 * creates ExtendedFTNode equivalent of provided FlexComponent
 * @param {FlexComponent} flexComponent
 * @param {DescendantDepth} descendantDepth specify depth of returned FlexTemplateNode tree
 * @returns ExtendedFTNode
 */
export const flexComponentToFlexTemplateNode = (
  flexComponent: FlexComponent,
  descendantDepth: DescendantDepth
): ExtendedFTNode => {
  const flexComponentName = getNameFromFlexComponent(flexComponent);
  const flexComponentView = flexComponent.view ? flexComponent.view : undefined;

  let view = flexComponentName;

  if (flexComponentView && flexComponentView !== "default") {
    view = `${view}_${flexComponentView}`;
  }

  const ajaxOnly = !!flexComponent.ajaxOnly;
  const clientSideOnly = !!flexComponent.clientSideOnly;

  const options = {
    ...flexComponent,
    ajaxOnly,
    clientSideOnly,
    flexComponentName,
    flexComponentView,
  } as any;

  if (flexComponentName === "tab" || flexComponentName === "region") {
    options.containerName = flexComponent.name;
  }

  delete options.id;
  delete options.name;
  delete options.modules;
  delete options.children;
  delete options.groups;
  delete options.model;

  const flexTemplateNode: ExtendedFTNode = {
    id: flexComponent.id,
    view,
    options,
  };

  if (
    (flexComponent.modules || flexComponent.groups || flexComponent.children) &&
    descendantDepth !== DescendantDepth.NONE
  ) {
    // gather and create decendant BlossomComponents
    const childFlexComponents: FlexComponent[] = [
      ...(flexComponent.modules || []),
      ...(flexComponent.groups || []),
      ...(flexComponent.children || []),
    ];

    const childNodes = childFlexComponents
      .map((child) => flexComponentToFlexTemplateNode(child, getNextDepth(descendantDepth)))
      .filter((node) => !!node);

    if (childNodes.length > 0) {
      flexTemplateNode.childNodes = childNodes;
    }
  }

  return flexTemplateNode;
};
